<script>
import { isDefined } from '../../utils/utils'
let dayjs = require('dayjs')
export default {
  name: 'FormItemDetail',
  props: {
    item: Object,
    value: [String, Number, Boolean, Array, Object, null, undefined],
  },
  computed: {
    valueText() {
      let text = '--'
      let { type, options, propKeys } = this.item
      if (isDefined(this.value)) {
        switch (type) {
          case 'week':
            text = dayjs(this.value).format('yyyy 第 WW 周')
            break
          case 'year':
            text = dayjs(this.value).format('YYYY')
            break
          case 'month':
            text = dayjs(this.value).format('YYYY-MM')
            break
          case 'date':
            text = dayjs(this.value).format('YYYY-MM-DD')
            break
          case 'daterange':
            text = `${dayjs(this.value[0]).format('YYYY-MM-DD')} - ${dayjs(
              this.value[1]
            ).format('YYYY-MM-DD')}`
            break
          case 'monthrange':
            text = `${dayjs(this.value[0]).format('YYYY-MM')} - ${dayjs(
              this.value[1]
            ).format('YYYY-MM')}`
            break
          case 'datetime':
            text = dayjs(this.value).format('YYYY-MM-DD HH:mm:ss')
            break
          case 'time':
            text = dayjs(this.value).format('HH:mm')
            break
          case 'timePicker':
            text = dayjs(this.value).format('HH:mm:ss')
            break
          case 'datetimerange':
            text = `${dayjs(this.value[0]).format(
              'YYYY-MM-DD HH:mm:ss'
            )} - ${dayjs(this.value[1]).format('YYYY-MM-DD HH:mm:ss')}`
            break
          case 'switch':
            text = this.value ? '是' : '否'
            break
          case 'number':
          case 'password':
          case 'textarea':
          case 'input':
          default:
            text = this.value
        }

        if (
          type === 'cascader' ||
          type === 'tree' ||
          type === 'selectTree' ||
          type === 'select' ||
          type === 'radio' ||
          type === 'checkbox'
        ) {
          let value = this.value
          if (type !== 'radio') {
            value = value || []
          }
          text = value2Label(options, value, propKeys)
        }
      }
      return text
    },
  },
  render() {
    return <div class="content-area">{this.valueText}</div>
  },
}

function value2Label(
  tree = [],
  value,
  propKeys = {
    label: 'label',
    value: 'value',
    children: 'children',
  }
) {
  let label = ''
  if (Array.isArray(value)) {
    value.forEach((v, i) => {
      let node = findTreeNode(tree, v, propKeys)
      if (node) {
        label += node[propKeys['label'] || 'label']
        if (i < value.length - 1) {
          label += '/'
        }
      }
    })
  } else {
    let node = findTreeNode(tree, value, propKeys)
    console.log(node, value, propKeys)
    if (node) {
      label = node[propKeys['label'] || 'label']
    }
  }
  return label
}
function findTreeNode(
  tree,
  value,
  propKeys = { label: 'label', value: 'value', children: 'children' }
) {
  let node = null
  for (let i = 0; i < tree.length; i++) {
    let item = tree[i]
    if (item[propKeys['value'] || 'value'] === value) {
      node = item
      break
    } else if (item[propKeys['children'] || 'children']) {
      node = findTreeNode(
        item[propKeys['children'] || 'children'],
        value,
        propKeys
      )
      if (node) {
        break
      }
    }
  }
  return node
}
</script>

<style lang="scss" scoped>
.content-area {
  white-space: pre-line;
}
</style>
